module.exports = __webpack_public_path__ + "static/screenshot1-61868d806913a6199336e47d8c789ca7.png";